<ng-template [cdkPortalOutlet]="dynamicMenuPortal"></ng-template>
